let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d6dBt")).then(() => parcelRequire('4HH5G'));